import Marquee from "react-fast-marquee";

import { m } from "@/paraglide/messages";
import { Link } from "@bidbattles/bloks/components/ui/link";
import { cn } from "@bidbattles/bloks/lib/ui";
import SiFacebook from "@icons-pack/react-simple-icons/icons/SiFacebook";
// import {
// 	// SiInstagram,
// 	SiFacebook,
// 	SiTiktok,
// } from "@icons-pack/react-simple-icons";
import SiInstagram from "@icons-pack/react-simple-icons/icons/SiInstagram";
import SiTiktok from "@icons-pack/react-simple-icons/icons/SiTiktok";

import Apple from "@/assets/svg/social-proof/apple.svg";
import Beats from "@/assets/svg/social-proof/beats.svg";
import Philips from "@/assets/svg/social-proof/g2853.svg";
import Lego from "@/assets/svg/social-proof/lego.svg";
import LV from "@/assets/svg/social-proof/lv.svg";
import Mercedes from "@/assets/svg/social-proof/mercedes.svg";
import Nike from "@/assets/svg/social-proof/nike.svg";
import Rolex from "@/assets/svg/social-proof/rolex.svg";
import Samsung from "@/assets/svg/social-proof/samsung.svg";
import Sonos from "@/assets/svg/social-proof/sonos.svg";
import Sony from "@/assets/svg/social-proof/sony.svg";
import Tesla from "@/assets/svg/social-proof/tesla.svg";
import { ButtonLink } from "@bidbattles/bloks/components/ui/button";
import {
	faArrowUp,
	faCheckCircle,
	faCircleQuestion,
	faPlayCircle,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ClientOnly } from "@tanstack/react-router";

export function Footer({ className }: { className?: string }) {
	const sections = [
		{
			label: "Auctions",
			items: [
				{ label: "All products", url: "/battles" },
				{ label: "How it works", url: "/how-it-works" },
				{ label: "Bid packages", url: "" },
				{ label: "History", url: "/history" },
			],
		},
		{
			label: "Account & Support",
			items: [
				{ label: "My account", url: "/settings" },
				{ label: "Help center", url: "/help-center" },
				{ label: "FAQ", url: "/how-it-works#faq-heading" },
			],
		},
		{
			label: "Legal & Company",
			items: [
				{ label: "About Bidbattles", url: "/about" },
				{ label: "Terms and conditions", url: "/terms" },
				{ label: "Privacy policy", url: "" },
			],
		},
		{
			label: "Community & Resources",
			items: [
				{ label: "Battle strategies guide", url: "" },
				{ label: "Success stories", url: "" },
				{ label: "Newsletter signup", url: "" },
			],
		},
	];

	const socialProofRows = [
		[
			{ logo: Tesla, alt: m.footer__auctions() },
			{ logo: Apple, alt: m.footer__auctions() },
			{ logo: Sonos, alt: m.footer__auctions() },
			{ logo: Rolex, alt: m.footer__auctions() },
			{ logo: Lego, alt: m.footer__auctions() },
			{ logo: LV, alt: m.footer__auctions() },
		],
		[
			{ logo: Beats, alt: m.footer__auctions() },
			{ logo: Sony, alt: m.footer__auctions() },
			{ logo: Nike, alt: m.footer__auctions() },
			{ logo: Samsung, alt: m.footer__auctions() },
			{ logo: Mercedes, alt: m.footer__auctions() },
			{ logo: Philips, alt: m.footer__auctions() },
		],
	];

	return (
		<footer className={cn("flex flex-col items-center", className)}>
			<div className="w-full bg-accent-primary p-box py-12 flex flex-col gap-4 items-center text-white">
				<div className="max-w-120 mb-2">
					<p className="font-bold text-3xl md:text-4xl mb-4">
						Ready to Start Winning?
					</p>
					<p>Join thousands of satisfied winners on BidBattles</p>
				</div>
				<div className="w-full flex flex-col md:flex-row items-stretch md:justify-center gap-4 mb-2">
					<ButtonLink
						variant="solid"
						className="bg-white border-white focus-visible:outline-white text-accent-primary font-bold"
						to="/battles"
					>
						Find Battle
					</ButtonLink>
					<ButtonLink
						variant="solid"
						to="/how-it-works"
						className="bg-[#B54708] border-[#B54708] focus-visible:outline-[#B54708] text-white flex items-center gap-2 justify-center"
					>
						<FontAwesomeIcon icon={faPlayCircle} />
						Learn How to Play
					</ButtonLink>
				</div>
				<ul className="flex flex-wrap justify-center text-sm gap-4">
					<li>
						<FontAwesomeIcon icon={faCheckCircle} /> Instant Delivery
					</li>
					<li>
						<FontAwesomeIcon icon={faCheckCircle} /> Never Expires
					</li>
					<li>
						<FontAwesomeIcon icon={faCheckCircle} /> Secure Payment
					</li>
					<li>
						<FontAwesomeIcon icon={faCheckCircle} /> 24/7 Support
					</li>
				</ul>
			</div>
			<nav className="max-w-container p-box w-full pt-16 pb-12 flex flex-wrap gap-8 justify-between">
				{sections.map((section) => (
					<div key={section.label}>
						<p className="mb-4 text-gray-900 font-semibold">{section.label}</p>
						<ul className="list-none flex flex-col gap-3">
							{section.items.map((item) => (
								<Link
									key={item.label}
									to={item.url}
									className="leading-6 text-gray-500"
								>
									{item.label}
								</Link>
							))}
						</ul>
					</div>
				))}
			</nav>
			<div className="flex flex-col gap-4 md:flex-row justify-between max-w-container p-box w-full py-12 text-gray-400">
				<p className="leading-6">
					&copy; {new Date().getFullYear()}, BidBattles. All rights reserved.
				</p>
				<ul className="flex gap-6 list-none">
					<li>
						<SiFacebook />
					</li>
					<li>
						<SiInstagram />
					</li>
					<li>
						<SiTiktok />
					</li>
				</ul>
			</div>
		</footer>
	);
}

export function TermsAcknowlegdementCard({
	className,
}: React.ComponentProps<"div">) {
	return (
		<div
			className={cn(
				"flex w-full max-w-3xl flex-col items-center gap-4 rounded-xl bg-white p-8 text-center text-gray-700 md:p-16",
				className,
			)}
		>
			<h2 className="text-2xl font-bold text-gray-900 md:text-3xl">
				Acknowledgment of Terms
			</h2>
			<p>
				By using BidBattles, you acknowledge that you have read, understood, and
				agree to be bound by these Terms and Conditions, including our Privacy
				Policy and Refund Policy. You also confirm that you meet all eligibility
				requirements and will comply with all applicable laws.
			</p>
			<div className="mt-2 flex w-full flex-col justify-center gap-3 sm:w-auto sm:flex-row">
				<ButtonLink
					to="."
					hash="top"
					variant="outline"
					className="border-accent-primary text-accent-primary hover:bg-gray-50 focus-visible:outline-accent-primary"
				>
					<FontAwesomeIcon aria-hidden icon={faArrowUp} />
					Back to Top
				</ButtonLink>
				<ButtonLink to="/help-center">
					<FontAwesomeIcon aria-hidden icon={faCircleQuestion} />
					Visit Help Center
				</ButtonLink>
			</div>
		</div>
	);
}
